module.exports = __webpack_public_path__ + "img/Equipa_Ergon_1.a843502f.png";